import { render, staticRenderFns } from "./OutlineGivings.vue?vue&type=template&id=74b6ff10&"
import script from "./OutlineGivings.vue?vue&type=script&lang=js&"
export * from "./OutlineGivings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports